"use client";

import Cookies from "js-cookie";

type SurveyCookieProps = {
  surveyId: string;
  surveyType: string;
};

export default function SurveyCookie({
  surveyId,
  surveyType,
}: SurveyCookieProps) {
  const cookieName = surveyType + "-cookie";
  Cookies.set(cookieName, JSON.stringify({ surveyId, surveyType }), {
    expires: 1, // TODO: check back in on thissetting this to expire after 1 day
    sameSite: "strict",
  });
}
